import {useState} from "react";
import {Typography} from "antd";
import {t} from "i18next";

export const TextCell = ({text, className, style,classNameParagraph}) => {
    const [expanded, setExpanded] = useState(false);
    const {Text, Paragraph} = Typography;

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    const truncatedText = text && (text?.length > 20 ? text?.slice(0, 20) + '...' : text);

    return (
        <div style={style} className={className}>
            <Paragraph className={classNameParagraph} ellipsis={{rows: 10000, expandable: false}}>
                {expanded ? text : truncatedText}
                {text?.length > 20 && (
                    <Text type="secondary" onClick={toggleExpanded} style={{cursor: 'pointer'}}>
                        {expanded ? t("tnp.common.ellipsis.less") : t("tnp.common.ellipsis.more")}
                    </Text>
                )}
            </Paragraph>

        </div>
    );
};